export const routes = {
  index: '/',
  cv: '/cv'
};
export default routes;
